import { isChallengesFieldType, isChallengesImageChoice, isMultipleAnswersOfMaxItems } from '../quiz-fields';
import { makeValidationOfInputField } from './make-validation-of-input-field';
import { makeViewOfDisplayProperties } from './make-view-of-display-properties';
import { makeViewOfInputField } from './make-view-of-input-field';
export function transformFieldToV1(field) {
    return {
        id: field.id,
        hidden: field.hidden,
        ...resolveRootProperties(field)
    };
}
function resolveRootProperties(field) {
    if (field.inputOptions) {
        return {
            pii: field.inputOptions.pii,
            target: field.inputOptions.target,
            readOnly: field.inputOptions.readOnly,
            view: {
                fieldType: field.identifier,
                ...makeInputView(field.identifier, field.inputOptions)
            },
            validation: makeInputValidation(field.identifier, field.inputOptions)
        };
    }
    if (field.displayOptions) {
        return {
            view: {
                fieldType: field.identifier,
                ...makeViewOfDisplayProperties(field.displayOptions)
            }
        };
    }
    return {};
}
function makeInputView(identifier, inputOptions) {
    const view = makeViewOfInputField(inputOptions);
    if (!isChallengesFieldType(identifier)) {
        return view;
    }
    const { score, correctAnswers, ...viewWithoutQuizData } = view;
    if (!isChallengesImageChoice(identifier)) {
        return viewWithoutQuizData;
    }
    return {
        ...viewWithoutQuizData,
        isMultipleAnswers: isMultipleAnswersOfMaxItems(inputOptions.arrayOptions?.validation?.maxItems)
    };
}
function makeInputValidation(identifier, inputOptions) {
    const validation = makeValidationOfInputField(inputOptions);
    if (!isChallengesImageChoice(identifier) || !validation.array) {
        return validation;
    }
    const { maxItems: _maxItems, ...array } = validation.array;
    return {
        ...validation,
        array
    };
}

//# sourceMappingURL=transform-field-to-v1.js.map